import { ORDER_STATUS } from "./constants";

export function getRecommendedOrderAction(status) {
  const map = {
    [ORDER_STATUS.SUBMITTED]: {
      label: "Mark awaiting confirmation",
      description: "Acknowledge the order and begin staff review.",
      variant: "ghost",
    },
    [ORDER_STATUS.PENDING_PAYMENT]: {
      label: "Awaiting online payment",
      description: "Customer must complete Paystack payment. Confirm is unavailable until paid.",
      variant: "ghost",
    },
    [ORDER_STATUS.AWAITING_CONFIRMATION]: {
      label: "Confirm order",
      description: "Verify stock and customer details, then confirm for fulfillment.",
      variant: "success",
    },
    [ORDER_STATUS.CONFIRMED]: {
      label: "Start processing",
      description: "Begin picking, packing, or procurement for this order.",
      variant: "teal",
    },
    [ORDER_STATUS.PROCESSING]: {
      label: "Mark ready for pickup or shipped",
      description: "Update fulfillment status based on delivery method.",
      variant: "primary",
    },
    [ORDER_STATUS.READY_FOR_PICKUP]: {
      label: "Mark delivered",
      description: "Customer collected the order — mark as delivered.",
      variant: "success",
    },
    [ORDER_STATUS.SHIPPED]: {
      label: "Mark delivered",
      description: "Confirm delivery to customer address.",
      variant: "success",
    },
    [ORDER_STATUS.DELIVERED]: {
      label: "Complete order",
      description: "Close the order after successful fulfillment.",
      variant: "outline",
    },
    [ORDER_STATUS.COMPLETED]: {
      label: "No further action",
      description: "Order is complete.",
      variant: "ghost",
    },
    [ORDER_STATUS.DECLINED]: {
      label: "No further action",
      description: "Order was declined.",
      variant: "ghost",
    },
    [ORDER_STATUS.CANCELLED]: {
      label: "No further action",
      description: "Order was cancelled.",
      variant: "ghost",
    },
  };
  return map[status] || { label: "Review order", description: "Check status and take the next step.", variant: "outline" };
}

export function getOrderLifecycleActions(status) {
  const s = status;
  const actions = {
    [ORDER_STATUS.SUBMITTED]: [
      { label: "Mark awaiting confirmation", target: ORDER_STATUS.AWAITING_CONFIRMATION, variant: "ghost" },
      { label: "Confirm order", target: ORDER_STATUS.CONFIRMED, variant: "success" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [ORDER_STATUS.PENDING_PAYMENT]: [
      { label: "Cancel", action: "cancel", variant: "danger" },
    ],
    [ORDER_STATUS.AWAITING_CONFIRMATION]: [
      { label: "Confirm order", target: ORDER_STATUS.CONFIRMED, variant: "success" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [ORDER_STATUS.CONFIRMED]: [
      { label: "Start processing", target: ORDER_STATUS.PROCESSING, variant: "teal" },
      { label: "Cancel", action: "cancel", variant: "ghost" },
    ],
    [ORDER_STATUS.PROCESSING]: [
      { label: "Ready for pickup", target: ORDER_STATUS.READY_FOR_PICKUP, variant: "primary" },
      { label: "Mark shipped", target: ORDER_STATUS.SHIPPED, variant: "teal" },
    ],
    [ORDER_STATUS.READY_FOR_PICKUP]: [
      { label: "Mark delivered", target: ORDER_STATUS.DELIVERED, variant: "success" },
    ],
    [ORDER_STATUS.SHIPPED]: [
      { label: "Mark delivered", target: ORDER_STATUS.DELIVERED, variant: "success" },
    ],
    [ORDER_STATUS.DELIVERED]: [
      { label: "Complete order", target: ORDER_STATUS.COMPLETED, variant: "success" },
    ],
    [ORDER_STATUS.COMPLETED]: [],
    [ORDER_STATUS.DECLINED]: [],
    [ORDER_STATUS.CANCELLED]: [],
  };
  return actions[s] || [];
}
